import AddEditActivity from "./AddEditActivity";

export default AddEditActivity;